module.exports = __webpack_public_path__ + "static/img/online.fb93d2e7.svg";